import { USER } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(USER);
const actions = { ...rawActions, ...thunkFactory(USER, '/users/') };
export { actions };

// REDUCER
const initialState = {
  data: [],
  dataById: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

const options = {
  orderBy: {
    what: ['username'],
    how: ['asc']
  },
};

export default reducerFactory(USER, initialState, options);

// SAGAS
const sagas = sagasFactory(USER, '/users/');
export { sagas };
